import React from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Shared Sign Out button for the mobile "More" screens (field tech + admin).
 * Wired to the single AuthContext logout, which purges all tenant-scoped
 * client state via purgeTenantData(). Do not fork the styles or the handler.
 */
export default function SignOutButton() {
  const { logout } = useAuth();

  return (
    <button
      type="button"
      onClick={logout}
      className="w-full mt-4 min-h-[44px] bg-red-500/20 text-red-400 rounded-xl p-4 flex items-center justify-center gap-2 font-semibold"
    >
      <LogOut size={20} /> Sign Out
    </button>
  );
}
